<template>
  <div class="workpush-page">
    <div class="container">
      <el-radio-group class="radio-box" v-model="radioValue" size="medium" @change="handleChange">
        <el-radio label="1" border>AI审核</el-radio>
        <el-radio label="2" border>人工审核</el-radio>
      </el-radio-group>
      <div class="submit-btn">
        <el-button type="primary" @click="saveFn">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
		data() {
			return {
        radioValue: 2,
        username: JSON.parse(sessionStorage.getItem('userinfo'))
      }
    },
    mounted () {
      this.getStateFn()
    },
    methods: {
      handleChange (val) {
        this.radioValue = val
      },
      // 审核状态查询
      getStateFn () {
        let data = {
          config_name: 'ai_check_conf',
        }
        this.api.checkInfo(data).then(res => {
          if (!res) return
          this.radioValue = JSON.parse(res.config_value).ai_check_type
        })
      },
      // 审核状态保存
      saveFn () {
        let data = {
          config_name: 'ai_check_conf',
          config_value: JSON.stringify({ai_check_type: this.radioValue}),
          edit_desc: `用户 ${this.username.name} 将审核修改为：${this.radioValue == 2 ? '人工审核' : 'AI审核'}`
        }
        this.api.checkEdit(data).then(res => {
          if (!res) return

          this.$message({ type: 'success', message: '保存成功' })

          this.getStateFn()
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .workpush-page {
    .container {
      text-align: center;
      .radio-box {
        margin: 60px 0 100px;
        
        .el-radio {
          display: inline;
          padding: 10px;
        }
      }
    }
  }
</style>